import React from "react";
import { ACCESS_TOKEN } from "../config.js";

export default function ProtectedRoute({ children }) {
  const params = new URLSearchParams(window.location.search);
  const token = params.get("api_key");

  if (token !== ACCESS_TOKEN) {
    return (
      <div style={{ padding: 20, textAlign: "center" }}>
        <h1>Acces forbidden</h1>
      </div>
    );
  }

  return children;
}
